module.exports = __webpack_public_path__ + "img/thumb-griffin2a@2x.96d1ec89.png";